export const routePath = {
	home: '/',
	login: '/login',
	alerts: '/locations/:locationId/alerts',
	locations: '/locations',
	error: '/error'
}
